import clsx from "clsx";

export type SkeletonRadius = "sm" | "md" | "lg" | "xl" | "full";

const RADIUS_CLASS: Record<SkeletonRadius, string> = {
  sm: "rounded",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-[10px]",
  full: "rounded-full",
};

type Props = {
  width?: number | string;
  height?: number;
  variant?: "rectangular" | "rounded";
  radius?: SkeletonRadius;
  motionReduce?: boolean;
  className?: string;
};

const makeStyle = ({ width, height }: Props) => {
  if (width === undefined && height === undefined) return;
  return { width, height };
};

export const SkeletonLoader = ({
  width,
  height,
  variant,
  radius,
  motionReduce,
  className,
}: Props) => {
  const resolvedRadius = radius ?? (variant === "rounded" ? "lg" : undefined);

  return (
    <div
      className={clsx(
        "animate-pulse bg-background-loading",
        motionReduce && "motion-reduce:animate-none",
        width === undefined && "w-full",
        height === undefined && "h-full",
        resolvedRadius && RADIUS_CLASS[resolvedRadius],
        className,
      )}
      style={makeStyle({ width, height })}
    />
  );
};
